import React from "react";
export default class BookingCustomerFields extends React.Component {

	constructor(props) {
    super(props);
  }

  componentDidUpdate () {
    if (typeof window.initDatepickers == 'function') {
      window.initDatepickers();
    }
    if (typeof window.initTypeahead == 'function' && this.refs.root) {
      window.initTypeahead($(this.refs.root).find("[data-model][data-column]"));
    }
  }

	render() {
		return (
			<div className="BookingCustomerFields">
				{this.renderDefaultFields()}
			</div>
		);
	}

  renderDefaultFields() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-6">
            <div className={"form-group " + this.hasError('first_name')}>
              <label>{I18n.t('first_name')}*</label>
              <input type="text" className="form-control" name="first_name" value={this.props.guest_information.first_name || ''} onChange={this.props.onChangeGuestInformation}  />
              {this.renderFieldError('first_name')}
            </div>
          </div>
          <div className="col-sm-6">
            <div className={"form-group " + this.hasError('last_name')}>
              <label>{I18n.t('last_name')}*</label>
              <input type="text" className="form-control" name="last_name" value={this.props.guest_information.last_name || ''} onChange={this.props.onChangeGuestInformation}  />
              {this.renderFieldError('last_name')}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className={"form-group " + this.hasError('email')}>
              <label>{I18n.t('email_address')}*</label>
              {
                this.props.guest_information && this.props.guest_information.id
                ?
                <input type="email" className="form-control" name="email" value={this.props.guest_information.email || ''} readOnly />
                :
                <input type="email" className="form-control" name="email" value={this.props.guest_information.email || ''} onChange={this.props.onChangeGuestInformation}  />
              }
              {this.renderFieldError('email')}
            </div>
          </div>
          <div className="col-sm-12">
            <div className={`form-group ${this.props.property.enable_messaging_terms ? 'mb-0' : ''} ${this.hasError('phone_number')}`}>
              <label>{I18n.t('mobile_number')}*</label>
              <input type="tel" className="form-control" name="formatted_phone" value={this.props.guest_information.formatted_phone || ''} onChange={this.props.onChangeGuestInformation}  />
              {this.renderFieldError('phone_number')}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderFieldError(name) {
    if (this.props.errors && Object.keys(this.props.errors).includes(name)) {
      return <span className="error">{this.props.errors[name][0]}</span>
    }
  }

  renderPasswordFields() {
    if (this.props.passwordFields && this.props.guest_information && !this.props.guest_information.google_token) {
      return (
        <div className="row">
          <div className="col-sm-6">
            <div className={"form-group " + this.hasError('password')}>
              <label>{I18n.t('password')}*</label>
              <input type="password" className="form-control" name="password" value={this.props.guest_information.password || ''} onChange={this.props.onChangeGuestInformation} />
              {this.renderFieldError('password_confirmation')}
            </div>
          </div>
          <div className="col-sm-6">
            <div className={"form-group " + this.hasError('password_confirmation')}>
              <label>{I18n.t('retype_password')}*</label>
              <input type="password" className="form-control" name="password_confirmation" value={this.props.guest_information.password_confirmation || ''} onChange={this.props.onChangeGuestInformation} />
              {this.renderFieldError('password_confirmation')}
            </div>
          </div>
        </div>
      );
    }
  }

  /** Helper functions **/

  hasError(name) {
    if (this.props.errors && Object.keys(this.props.errors).includes(name)) {
      return 'has-error'
    }
  }

}
